import React from "react";
import { Route, Redirect } from "react-router-dom";

import { getSession } from "../redux/actions/authActions";

const ProtectedRoute = ({ component: Component, ...rest }) => {
  const { token } = getSession();

  return (
    <Route
      {...rest}
      render={(props) =>
        token ? <Component {...props} /> : <Redirect to="/" />
      }
    />
  );
};

export default ProtectedRoute;
